module.exports = __webpack_public_path__ + "img/1557614075789254658.c74805bd.png";